/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TableDataInfo } from '../models/TableDataInfo';
import type { XiaoniuStudyMaterial } from '../models/XiaoniuStudyMaterial';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class XiaoniuStudyMaterialControllerService {

    /**
     * 获取学习资料列表
     * @param requestBody 查询条件
     * @returns TableDataInfo OK
     * @throws ApiError
     */
    public static listUsingGet20(
        requestBody?: XiaoniuStudyMaterial,
    ): CancelablePromise<TableDataInfo> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/baseinfo/fronted/studyMaterial/list',
            query: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }

    /**
     * 获取学习资料详情
     * @param id id
     * @returns any OK
     * @throws ApiError
     */
    public static getInfoUsingGet21(
        id: number,
    ): CancelablePromise<Record<string, Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/baseinfo/fronted/studyMaterial/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }

    /**
     * 获取热门学习资料Top5
     * @returns any OK
     * @throws ApiError
     */
    public static topFiveUsingPost(): CancelablePromise<Record<string, Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/baseinfo/fronted/studyMaterial/topFive',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }

    /**
     * 增加学习资料浏览量
     * @param id id
     * @returns any OK
     * @throws ApiError
     */
    public static addViewUsingPost(
        id: number,
    ): CancelablePromise<Record<string, Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/baseinfo/fronted/studyMaterial/addView/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }

    /**
     * 创建学习资料订单
     * @param requestBody 订单信息
     * @returns any OK
     * @throws ApiError
     */
    public static addOrderUsingPost(
        requestBody?: XiaoniuStudyMaterial,
    ): CancelablePromise<Record<string, Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/baseinfo/fronted/studyMaterial/order',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }

    /**
     * 支付学习资料订单
     * @param orderNo 订单号
     * @returns any OK
     * @throws ApiError
     */
    public static payOrderUsingPost(
        orderNo: string,
    ): CancelablePromise<Record<string, Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/baseinfo/fronted/studyMaterial/pay/{orderNo}',
            path: {
                'orderNo': orderNo,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }
}
